import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import {
  ManagerCommunicationResponse,
  NewsFeedResponse,
  NewsFeedListDataResponse,
} from './interfaces';
import { VersionConfigService } from '../../../services/version-config';
import { skipWhile, map, distinctUntilChanged } from 'rxjs/operators';
import { CoreDataService } from '../core.data';
import { API } from '@app/core/models';
import { Observable } from 'rxjs';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class NewsFeedHttpService {
  private _urlPrefix!: string;
  imagesBaseUrl!: string;

  constructor(
    private _versionConfigService: VersionConfigService,
    private _coreDataService: CoreDataService,
    private _platform: Platform,
  ) {
    this._versionConfigService
      .getVersionConfig()
      .pipe(
        skipWhile((config) => !config || !config.api?.active),
        map((config) => config?.api?.prefix.newsfeed),
        distinctUntilChanged(),
      )
      .subscribe((version) => {
        this._urlPrefix = `${version}/newsfeed/`;
        this.imagesBaseUrl = this._urlPrefix + 'get-manager-news-feed-image';
      });
  }

  get urlPrefix() {
    return this._urlPrefix;
  }

  postCommunicationNewsFeed(
    entIds: Array<string>,
    channelId: number,
    text: string,
    images: Array<string>,
  ): Observable<NewsFeedResponse> {
    const options: API.HttpOptions = !this._platform.is('capacitor')
      ? {
          headers: new HttpHeaders(),
          withCredentials: true,
        }
      : {};

    const body = {
      newsFeed: {
        text,
        channelId,
        images,
      },
      entIds,
    };

    return this._coreDataService.post<NewsFeedResponse>(
      `${this._urlPrefix}post-newsfeed`,
      body,
      options,
    );
  }

  getCommunicationNewsFeed(entIds: Array<string>, pageNumber = 1) {
    const options: API.HttpOptions = {
      headers: new HttpHeaders(),
      withCredentials: true,
      params: {},
    };
    options.params = this._coreDataService.getHttpParams({
      entIds,
      requestPageNumber: pageNumber,
      requestPageLimit: this._versionConfigService.newsFeedPageLimit,
    });
    return this._coreDataService.get<NewsFeedListDataResponse>(
      `${this._urlPrefix}get-manager-newsfeed`,
      options,
    );
  }

  postDeleteNewsFeedItem(newsFeedId: string) {
    const options: API.HttpOptions = !this._platform.is('capacitor')
      ? {
          headers: new HttpHeaders(),
          withCredentials: true,
        }
      : {};
    const body = {
      newsFeedId,
    };

    return this._coreDataService.post<NewsFeedResponse>(
      `${this._urlPrefix}post-delete-newsfeed`,
      body,
      options,
    );
  }

  getManagerCommunicationData(): Observable<ManagerCommunicationResponse> {
    const headers = new HttpHeaders();
    const options = {
      headers,
      withCredentials: true,
    };

    return this._coreDataService.get<ManagerCommunicationResponse>(
      `${this._urlPrefix}get-manager-channels-and-hotels`,
      options,
    );
  }
}
